import Logo from "../assets/Mainlogo.svg";
import LogoDark from "../assets/MainlogoDark.svg";
import DesktopImg from "../assets/home/rightImage.png";
import cl1 from "../assets/clients/cl1.png";
import cl2 from "../assets/clients/cl2.png";
import cl3 from "../assets/clients/cl3.png";
import cl4 from "../assets/clients/cl4.png";
import cl5 from "../assets/clients/cl5.png";
import cl6 from "../assets/clients/cl6.png";
import cl7 from "../assets/clients/cl7.png";
import cl8 from "../assets/clients/cl8.png";
import star from "../assets/icon/Star.svg";
import starWhite from "../assets/icon/starWhite.svg";
import card from "../assets/icon/card.svg";
import dash from "../assets/icon/dash.svg";
import list from "../assets/icon/list.svg";
import pie from "../assets/icon/pie.svg";
import bank from "../assets/icon/bank.svg";
import arc from "../assets/icon/arc.svg";
import ultick from "../assets/icon/ultick.svg";
import circledot from "../assets/icon/circledot.svg";
import doller from "../assets/icon/doller.svg";
import bankhouse from "../assets/icon/bankhouse.svg";
import housebank from "../assets/icon/housebank.svg";
import lin from "../assets/icon/social/in.svg";
import fb from "../assets/icon/social/fb.svg";
import twitter from "../assets/icon/social/twitter.svg";
import you from "../assets/icon/social/you.svg";
import insta from "../assets/icon/social/insta.svg";
import happy from "../assets/icon/happy.svg";
import investor from "../assets/icon/investor.svg";
import parentshappy from "../assets/icon/parentshappy.svg";
import tax from "../assets/icon/tax.svg";
import rippleavatar from "../assets/rippleavatar.png"

import taxfilling from "../assets/home/runBusiness/taxfilling.png"
import accounting from "../assets/home/runBusiness/accounting.svg";
import cfoservices from "../assets/home/runBusiness/cfoservices.png"
import hillgraph from "../assets/home/runBusiness/accessgrowth.png"
import payrollchart from "../assets/home/runBusiness/payroll.png"


import tickoutlinecircle from "../assets/icon/tickoutlinecircle.svg";

import arcblack from "../assets/icon/arcblack.svg";
import usersquare from "../assets/icon/usersquare.svg";
import house from "../assets/icon/house.svg";
import tickcircle from "../assets/icon/tickcircle.svg";
import TaxFillingComp from "../components/TaxFillingComp";
import PollGraph from "../components/PollGraph";
import AccountingList from "../components/AccountingList";
import CfoService from "../components/CfoService";
import HillGraph from "../components/HillGraph";

import pricingbg from "../assets/pricingbg.svg"

import accessCapImg from "../assets/home/AccessCapital.png"
import MISRImg from "../assets/home/MISReports.png"

import caImg from "../assets/home/ca_img.jpg"
import caBImg from "../assets/home/ca_blue_bg.png"

import secimg from "../assets/sec.png"
import CheckMark from "../assets/Check.png"
import CheckMarkSVG from "../assets/Check.svg"

import deliverydashboard from "../assets/home/deliverydashboard.png";
import AIAccountingCard from "../components/AIAccontingCards";

import IHimg1 from "../assets/industries/hero/img1.png";
import IHimg2 from "../assets/industries/hero/img2.png";
import IHimg3 from "../assets/industries/hero/img3.png";


const assets = {
  Logo, LogoDark, 
  twitter, insta, you, lin, fb,
  investor,
  tax,
  parentshappy,
  rippleavatar,
  DesktopImg,
  cl1,
  cl2,
  housebank, bankhouse, doller,
  circledot,
  cl3,
  cl4,
  cl5,
  cl6,
  cl7,
  cl8,
  star,
  starWhite,
  ultick,
  tickcircle,
  card,
  dash,
  list,
  happy,
  pie,
  house,
  usersquare,
  bank,
  arc,
  arcblack,
  deliverydashboard,
  tickoutlinecircle,
  taxfilling,
  accounting,
  cfoservices,
  payrollchart,
  hillgraph,
  secimg,
  CheckMark,
  CheckMarkSVG,
  pricingbg,
  caImg,
  caBImg,
  IHimg1,
  IHimg2,
  IHimg3,

};

// ✅ Using imported assets for client images
export const assetsClients = [
  { src: cl1 },
  { src: cl2 },
  { src: cl3 },
  { src: cl4 },
  { src: cl5 },
  { src: cl6 },
  { src: cl7 },
  { src: cl8 },
];

export const runbusiness = [
  {
    id: 1,
    title: "Day to Day Accounting & Financial insights",
    content:
      "100%compliant accounting with real time insights, what more could you ask for?",
    isSpecial: true,
    subContent: [{ type: "component", component: <AccountingList /> }],
  },
  {
    id: 2,
    title: "Tax fillings",
    content: " Ontimeandaccurate tax filings",
    isSpecial: true,
    subContent: [{ type: "component", component: <TaxFillingComp /> }],
  },
  {
    id: 3,
    title: " Payroll",
    content: " Stress free, effortless and compliant payroll processing",
    isSpecial: true,
    subContent: [{ type: "component", component: <PollGraph /> }],
  },
  {
    id: 4,
    title: "Virtual CFO services",
    content:
      "Growrevenues and profit margins while controlling exesnes with an expert financial advisor",
    isSpecial: true,
    subContent: [{ type: "component", component: <CfoService /> }],
  },
  {
    id: 5,
    title: "Access growth capital",
    content:
      "getapproved from financing partners to fund AD spend &Inventory",
    isSpecial: true,
    subContent: [{ type: "component", component: <HillGraph /> }],
  },
  // {
  //   id: 5,
  //   title: "Access growth capital",
  //   content: "getapproved from financing partners to fund AD spend &Inventory",
  //   isSpecial: true,
  //   subContent: [{ type: "text", component: <HillGraph /> }],
  // },
];

export const reportsec = [
  { icon: list, text: "Executive Summary", src: tickcircle },
  { icon: card, text: "Profit & Loss", src: tickcircle },
  { icon: pie, text: "Balance Sheet", src: tickcircle },
  { icon: dash, text: "Cash Flows", src: tickcircle },
];

export const AIAcnt = [
  {
    id: "realtime",
    tabName: "Realtime Accounting",
    title: "Realtime accounting powered by AI",
    description: "100% compliant accounting, tax & payroll, Instantly Audit ready- confidently share with Investors and Lenders",
    type: "component",
    content: <AIAccountingCard />
  },
  {
    id: "mis",
    tabName: "MIS Reports",
    title: "MIS reports",
    description: "Financial summary delivered to you: daily, weekly monthly or access anytime on your dashboard",
    type: "image",
    content: MISRImg
  },
  {
    id: "capital",
    tabName: "Access Capital",
    title: "Access Capital",
    description: "Accelerate growth with access to capital- get approved for loans to fund AD Spend or Inventory",
    type: "image",
    content: accessCapImg
  }
]


export const securitynote = [
  {
    icon: bank,
    text: " 256 bit Bank-grade Encryption",
    content:
      "Customer data is encrypted at rest and in transit using secure protocols",
  },
  {
    icon: usersquare,
    text: "Consent & Access Control",
    content:
      " Client data is secure with strict access control rules and OTP based consent authentication",
  },
  {
    icon: house,
    text: "Secure data storage and Cyber-Security audits",
    content:
      "data is stored and backed up with robust firewalls and data loss measures",
  },
];

export const plans = [
  {
    title: "Day to Day Accounting + MIS reports",
    description: "Reliable bookkeeping to cover your financial reporting needs with 100% compliance.",
    price: "₹4200",
    billing: "billed annually",
    features: [
      { text: "Toola Accounting Software" },
      { text: "Dedicated customer success manager & accountant" },
      { text: "Weekly + monthly bookkeeping" },
      { text: "P&L and balance sheets" },
      { text: "Live dashboard + MIS reports" },
      { text: "Real-time insights" },
      { text: "Custom reporting" },
      { text: "Graphical data visualization" }
    ],
    isFeatured: false,
    primarybtn: "Get Started",
    secondarybtn: "Book a Demo"
  },
  {
    title: "Add on Compliance & Tax Filing",
    description: "Full-service tax services including GST, TDS, and Annual Income Tax.",
    price: "₹2999",
    billing: "billed annually",
    features: [
      { text: "GSTFiling" },
      { text: "TDS/TCSmanagement" },
      { text: "Incometax filing" },
      { text: "AoC/MGTfiling" },
      { text: "LLPannual filling" },
      { text: "Director KYC" }
    ],
    isFeatured: true,
    primarybtn: "Get Started",
    secondarybtn: "Book a Demo"
  },
  {
    title: "Add on Payroll",
    description: "Everything you need to run payroll will 100% compliance.",
    price: "₹3499",
    billing: "billed annually",
    features: [
      { text: "Offer letters & Onboarding" },
      { text: "Payroll Preparation" },
      { text: "Time& Attendance monitoring" },
      { text: "Paysilp Generation" },
      {
        text: "Labour law compliance",
        subpoints: ["Professional tax", "Professional tax", "ESICfilings"]
      }
    ],
    isFeatured: false,
    primarybtn: "Add on Payroll",
    secondarybtn: ""
  },
];

export const excellence = [
  {
    id: 1,
    title: "Every Week",
    content: "Review validate and reconcile financial summaries & data",
    isSpecial: true,
    subContent: [
      {
        id: 1,
        icon: tickoutlinecircle,
        text: "Classify Transactions: sales, purchases & expenses",
      },
      { id: 2, icon: tickoutlinecircle, text: "Ecommerce & payment settlement reports" },
      { id: 3, icon: tickoutlinecircle, text: "Update general ledger, vendors and customer master lists" },
      { id: 4, icon: tickoutlinecircle, text: "Review and update inventory" },
    ],
  },
  {
    id: 2,
    title: "Every month",
    content: "We make sure every transaction is accounted for and reconciled. access data you can trust and confidently make decision and share with Investors or Lenders",
    isSpecial: true,
    subContent: [
      {
        id: 1,
        icon: tickoutlinecircle,
        text: "Close books, generate P&L and Balance Sheet",
      },
      { id: 2, icon: tickoutlinecircle, text: " File GST & TDS returns" },
      { id: 3, icon: tickoutlinecircle, text: "Process payroll" },
      { id: 4, icon: tickoutlinecircle, text: "Audit ready financials" },
    ],
  },
];

export const accountants = [
  { icon: happy, head: "You're happy", subhead: "Get financial insights, summaries and MIS reports delivered in real time or on demand" },
  { icon: investor, head: "Lenders and Investors are happy", subhead: "With real time data lenders can approve loans in minutes and you can share upto date reports to investors" },
  { icon: tax, head: "Tax authorities are happy", subhead: "GST and TDS are accurately calculated and filed on time" },
  { icon: parentshappy, head: "Mom & Dad are happy", subhead: "Mom is always proud of her baby but dad is proud of your financial discipline" },
];

export const newsecuritynote = [
  {
    icon: bank,
    text: " 256 bit Bank-grade Encryption",
    content:
      "Customer data is encrypted at rest and in transit using secure protocols",
  },
  {
    icon: usersquare,
    text: "Consent & Access Control",
    content:
      " Client data is secure with strict access control rules and OTP based consent authentication",
  },
  {
    icon: house,
    text: "Secure data storage and Cyber-Security audits",
    content:
      "data is stored and backed up with robust firewalls and data loss measures",
  },
];

export const betterservice = [
  {
    icon: bankhouse,
    text: "  Gain financial clarity and control with Toola accounting software",
    content:
      "All-in-one accounting platform with seamless setup and integration with your business tools. 100% compliant accounting",
  },
  {
    icon: doller,
    text: "Understand your money ",
    content:
      "Real-time MIS reports and financial insights for smarter decisions. Confidently share with Investors and lenders",
  },
  {
    icon: housebank,
    text: "AI enabled Charted accountants",
    content:
      "Qualified teams for startups and eCommerce, providing expert support and quick answers whenever you need them.",
  },
];

export const menuData = [
  {
    "heading": "Quick Navigation",
    "items": [
      {
        "name": "Home",
        "url": "/"
      },
      {
        "name": "Industries",
        "url": "/"
      },
      {
        "name": "Pricing",
        "url": "/pricing"
      },
      {
        "name": "Blog",
        "url": "/blog"
      },
      {
        "name": "Login",
        "url": "/"
      }
    ]
  },
  {
    "heading": "Legal",
    "items": [
      {
        "name": "Terms of Service",
        "url": "/terms-of-service"
      },
      {
        "name": "Privacy Policy",
        "url": "/privacy-policy"
      }
    ]
  }
];

export const iconData = [
  { name: "instagram", icon: insta },
  { name: "linked In", icon: lin, url: "https://www.linkedin.com/company/toola-finance/" },
  { name: "twitter", icon: twitter },
  { name: "facebook", icon: fb },
  { name: "youtube", icon: you }
];

export default assets;
